import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-navy text-white relative z-10 border-t-2 border-citrine" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Logo light />
            <p className="mt-6 font-sans text-sm text-white/60 leading-relaxed max-w-xs">
              Financial Solutions for Businesses. Wealth Solutions for Individuals.
            </p>
          </div>

          <FooterCol
            title="Products"
            links={[
              { name: "MF, PMS & AIF", to: "/products/mf-pms-aif" },
              { name: "Direct Equity & Trading", to: "/products/direct-equity" },
              { name: "Fixed Income & Insurance", to: "/products/fixed-income-insurance" },
              { name: "DAAE — Alpha Engine", to: "/products/daae" },
            ]}
          />
          <FooterCol
            title="Resources"
            links={[
              { name: "Start Investing", to: "/start-investing" },
              { name: "Build Wealth Through SIP", to: "/sip-investment" },
              { name: "Plan for Retirement", to: "/retirement-planning" },
              { name: "Calculators", to: "/calculators" },
              { name: "Learning", to: "/blog" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { name: "Business", to: "/business" },
              { name: "Individual", to: "/individual" },
              { name: "About", to: "/about" },
              { name: "Contact", to: "/contact" },
              { name: "Privacy Policy", to: "/privacy" },
            ]}
          />
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="font-data text-xs text-white/50 leading-relaxed max-w-4xl">
            Rao Investment Solutions is an AMFI-registered Mutual Fund Distributor (ARN-261755). Mutual fund investments
            are subject to market risks. Read all scheme related documents carefully before investing.
            Past performance is not indicative of future results. PMS and AIF products carry higher risk
            and are intended for eligible investors (PMS minimum ₹50 lakh, AIF minimum ₹1 crore per SEBI).
            Insurance is the subject matter of solicitation. The DAAE (Dynamic Asset Allocation Engine) is a
            rules-based allocation framework; all outputs and calculator results across this site are
            illustrative estimates based on stated assumptions and are not guarantees of returns.
          </p>
          <div className="mt-6 flex flex-col md:flex-row justify-between gap-4 text-xs font-sans text-white/40">
            <span>© {new Date().getFullYear()} Rao Enterprises. All rights reserved.</span>
            <span>ARN-261755 · AMFI-registered Mutual Fund Distributor</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="font-sans text-xs uppercase tracking-[0.24em] text-citrine mb-5">{title}</h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="font-sans text-sm text-white/70 hover:text-white transition-colors">
            {l.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
